import Styled from './sectionServices.module.css'
import * as FI from 'react-icons/fi'
import * as FA from 'react-icons/fa'
import { useLandingContext } from '../../../Context'
import * as CG from '../../../Components/Global'
import HTMLReactParser from 'html-react-parser'

const SectionServices = () => {
    const useLanding = useLandingContext()

    return (
        <section id="servicos" className={Styled.container_services}>
            <CG.H2>Serviços</CG.H2>
            <div className={Styled.container_card_services}>
                <article className={Styled.card_sevices}>
                    <div className={Styled.icon_roudend}>
                        <FA.FaHandsHelping />
                    </div>
                    <div className={Styled.group_text}>
                        <h4>Atendimentos <FA.FaHandsHelping /></h4>
                        <p>{HTMLReactParser(useLanding.websiteSettings.attendance)}</p>
                    </div>
                </article>
                <article className={Styled.card_sevices}>
                    <div className={Styled.icon_roudend}>
                        <FI.FiMic />
                    </div>
                    <div className={Styled.group_text}>
                        <h4>Palestras <FI.FiMic /></h4>
                        <p>{HTMLReactParser(useLanding.websiteSettings.speeches)}</p>
                    </div>
                </article>
                <article className={Styled.card_sevices}>
                    <div className={Styled.icon_roudend}>
                        <FI.FiBookOpen />
                    </div>
                    <div className={Styled.group_text}>
                        <h4>Livros <FI.FiBookOpen /> </h4>
                        <p>{HTMLReactParser(useLanding.websiteSettings.books)}</p>
                    </div>
                </article>
                <article className={Styled.card_sevices}>
                    <div className={Styled.icon_roudend}>
                        <FI.FiMonitor />
                    </div>
                    <div className={Styled.group_text}>
                        <h4>Cursos <FI.FiMonitor /></h4>
                        <p>{HTMLReactParser(useLanding.websiteSettings.courses)}</p>
                    </div>
                </article>
            </div>
        </section>
    )
}

export default SectionServices